import React from 'react';
import PropTypes from 'prop-types';

import { Tab, Tabs } from 'react-bootstrap-5';

import CustomFieldsConfig from 'bundles/apex/custom_fields/config';
import PlaybooksConfig from 'bundles/apex/playbooks/config';

export default function ApexSettings({ customFieldsConfigProps, playbooksConfigProps }) {
  if (!customFieldsConfigProps && !playbooksConfigProps?.showListingPlaybooks) {
    return <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="deal" />;
  }

  return (
    <Tabs defaultActiveKey="dealPlaybooks" id="apex-settings" unmountOnExit>
      <Tab eventKey="dealPlaybooks" title="Deals">
        <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="deal" />
      </Tab>
      { playbooksConfigProps?.showListingPlaybooks && (
        <Tab eventKey="listingPlaybooks" title="Listings">
          <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="listing"/>
        </Tab>
      )}
      { customFieldsConfigProps && (
        <Tab eventKey="customFields" title="Custom Fields">
          <CustomFieldsConfig {...customFieldsConfigProps} />
        </Tab>
      )}
    </Tabs>
  );
}

ApexSettings.propTypes = {
  customFieldsConfigProps: PropTypes.object,
  playbooksConfigProps: PropTypes.shape({
    showListingPlaybooks: PropTypes.bool,
  }).isRequired,
};
